import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { IRewardTransQuantity } from '../models/reward'
import { buildRewardTransQuantityLabel } from '../service/rewardTransService'


export default /*#__PURE__*/_defineComponent({
  __name: 'RewardTransImage',
  props: {
    bg: null,
    rewardIcon: null,
    alt: { default: '' },
    size: { default: 180 },
    compact: { type: Boolean, default: false },
    quantity: { default: null }
  },
  setup(__props: any) {

const props = __props as { bg: string, rewardIcon: string, alt: string, size: number, compact: boolean, quantity: IRewardTransQuantity | null };



const designSize = 180

const rootStyle = computed(() => {
  const scale = props.size / designSize

  return {
    width: `${props.size / 12}rem`,
    height: `${props.size / 12}rem`,
    '--scale': `${scale}`,
  }
})

const quantityStyle = computed(() => props.quantity?.style || {})

const quantityLabel = computed(() => (props.quantity ? buildRewardTransQuantityLabel(props.quantity) : ''))

return { __sfc: true,props, designSize, rootStyle, quantityStyle, quantityLabel }
}

})